<template>
  <div class="container-full">
    <div class="logo-content">
      <img
        alt="logo"
        src="../../assets/layout/images/logo_quality.png"
        class="p-mr-2 logo"
        @click="
          getUserData.cambiar_password == 1
            ? false
            : $router.push({ name: 'main' }).catch(() => {})
        "
        style="cursor:pointer"
      />
    </div>
    <div class="data-content">
      <div class="container-info">
        <div>
          <i class="mdi mdi-clock-outline" />
        </div>
        <div>
          <p>{{ $t("messages.mondayToSaturday") }}</p>
          <p>7:00 a.m. a 6:00 p.m.</p>
        </div>
      </div>
      <div class="container-info">
        <div>
          <i class="mdi mdi-comment-outline" />
        </div>
        <div>
          <p>(031) 3849060</p>
          <p>/61/62-69</p>
        </div>
      </div>
      <div class="container-info">
        <div>
          <i class="mdi mdi-map-outline" />
        </div>
        <div>
          <p>{{ $t("messages.addressUbication") }}</p>
          <p>{{ $t("messages.addressOfOffice") }}</p>
          <p>Bogotá</p>
        </div>
      </div>
    </div>
    <div class="show-menu">
      <Menubar :model="menuTranslated" class="headerCustom"/>      
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ContactHeader",
  computed: {
    ...mapGetters(["getUserData", "itemsMenuWithSubMenu", "itemsMenu"]),
    menuTranslated() {
      return this.itemsMenu.map((item) => {
        return {
          label: this.$t(item.label),
          to: item.to,
          icon: item.icon,
          items: item.items
            ? item.items.map((subItem) => {
                return {
                  label: this.$t(subItem.label),
                  to: subItem.to,
                  icon: subItem.icon,
                };
              })
            : null,
        };
      });
    },
  },
};
</script>

<style scoped>
.container-full {
  display: flex;
  width: 100%;
  background-color: #ffffff;
  height: 90px;
}
.logo-content {
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  user-select: none;
  padding-right: 70px;
}
.data-content {
  width: 60%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.container-info {
  height: 100%;
  width: 250px;
  display: flex;
  flex-wrap: wrap;
  padding-top: 12px;
}
.container-info div {
  padding: 5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
}
.container-info div p {
  margin: 0px;
  padding: 0px;
  color: black;
}
.container-info div:first-child {
  color: #4d86d9;
  font-size: 30px;
}

.logo {
  height: 50px;
  width: auto;
}

.headerCustom {
  width: 100%;
  justify-content: center;
}

.show-menu {
  display: none;
}
@media screen and (max-width: 960px) {
  .show-menu {
    display: flex;
    width: 50%;
  }
  .logo-content {
    width: 50%;
    padding-right: 30px;
  }
  .data-content {
    display: none;
  }
  .logo {
    height: 40px;
    width: auto;
  }
}
</style>
